import { createPinia, setActivePinia } from 'pinia'

import { logger } from '~/features-shared/libs/utils/logger'

const pinia = createPinia()

// TODO: Tracker about store
// pinia.use(({ store }) => {
//   store.$subscribe((...a) => {
//     debugger
//     // react to store changes
//   })
//   store.$onAction((...a) => {
//     debugger
//     // react to store actions
//   })
// })

setActivePinia(pinia)

logger.log('PINIA ', pinia)

export { pinia }
